const mutations = {
  showDialog(state) {
    state.dialog = true;
  },

  hideDialog(state) {
    state.dialog = false;
  },

  setModel(state, model) {
    state.errorArray = [];
    state.cursado = model;
  },

  setCiclos(state, data) {
    state.ciclosLectivos = data;
  },

  setModels(state, data) {
    state.cursados = data.models;
    state.pagination = data.headers;
    state.pagination.totalCount = +data.headers["x-pagination-total-count"];
  },

  addModel(state, model) {
    state.cursados.unshift(model);
  },

  delModel(state, id) {
    const removeIndex = state.cursados
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.cursados.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};

export default mutations;
